import CartCheckBagIcon from '@/components/icons/cart-check-bag';
import { preloadManagedDrawer } from '@/components/ui/drawer/lazy-managed-drawer';
import cn from 'classnames';
import Button from '@/components/ui/button';
import { ButtonProps } from '@/types';
import { useAtom } from 'jotai';
import { drawerAtom } from '@/store/drawer-atom';
import { useCart } from '@/store/quick-cart/cart.context';
import { useState, useEffect } from 'react';

const ShopButton = ({
  size = 'small',
  className = 'font-semibold',
}: Readonly<Pick<ButtonProps, 'title' | 'size' | 'className'>>) => {
  const [_, setDisplayCart] = useAtom(drawerAtom);
  const { totalUniqueItems } = useCart();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Button
      className={cn(
        className,
        'relative flex flex-col items-center justify-center gap-y-1 h-auto hover:bg-transparent',
      )}
      size={size}
      onClick={() => setDisplayCart({ display: true, view: 'cart' })}
      onMouseEnter={preloadManagedDrawer}
      onFocus={preloadManagedDrawer}
      onTouchStart={preloadManagedDrawer}
    >
      <CartCheckBagIcon
        className="shrink-0 filter brightness-[500]"
        width={18}
        height={18}
      />
      Carrinho
      {mounted && totalUniqueItems > 0 && (
        <span className="absolute top-0 mt-0.5 border border-white rounded-full bg-yellow-500 py-1 px-2 text-xs font-semibold leading-none text-black ltr:right-0 ltr:-top-1 ltr:-mr-0.5 rtl:left-0 rtl:-ml-0.5">
          {totalUniqueItems}
        </span>
      )}
    </Button>
  );
};

export default ShopButton;
